import { CHECKOUT_SESSION_TYPES } from '@/lib/constants';
import type { CheckoutSessionType } from '@/generated/graphql';

/**
 * @function isBillingAgreementWithoutPurchaseFlow
 * @param {object} checkoutSessionType
 * @returns {boolean}
 * @description given checkoutSessionType tells if its without purchase flow
 */
export const isBillingAgreementWithoutPurchaseFlow = (
  checkoutSessionType: CheckoutSessionType | null | undefined,
): boolean =>
  checkoutSessionType === CHECKOUT_SESSION_TYPES.BILLING_WITHOUT_PURCHASE;
